import { useState, useEffect } from 'react';
import { BACKEND_URL } from '../utils';

export function useAuth() {
  const [authUser, setAuthUser] = useState(null);
  const [authToken, setAuthToken] = useState(null);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [statsModalOpen, setStatsModalOpen] = useState(false);

  // Initialize auth from localStorage on mount
  useEffect(() => {
    try {
      const storedToken = localStorage.getItem('auth_token');
      const storedUser = localStorage.getItem('auth_user');
      if (storedToken && storedUser) {
        const user = JSON.parse(storedUser);
        setAuthToken(storedToken);
        setAuthUser(user);

        fetch(`${BACKEND_URL}/api/auth/me`, {
          headers: { 'Authorization': `Bearer ${storedToken}` }
        })
          .then(res => res.json())
          .then(data => {
            if (data.success && data.user) {
              setAuthUser(data.user);
              localStorage.setItem('auth_user', JSON.stringify(data.user));
            } else {
              localStorage.removeItem('auth_token');
              localStorage.removeItem('auth_user');
              setAuthToken(null);
              setAuthUser(null);
            }
          })
          .catch(() => {});
      }
    } catch (e) {}
  }, []);

  const handleLogin = (user, token) => {
    setAuthUser(user);
    setAuthToken(token);
  };

  const handleLogout = async () => {
    try {
      await fetch(`${BACKEND_URL}/api/auth/logout`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${authToken}` }
      });
    } catch (e) {}
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
    setAuthUser(null);
    setAuthToken(null);
  };

  const openLoginModal = () => setAuthModalOpen(true);

  return {
    authUser, authToken,
    authModalOpen, setAuthModalOpen,
    statsModalOpen, setStatsModalOpen,
    handleLogin, handleLogout, openLoginModal,
  };
}
